import { __awaiter, __generator } from "tslib";
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-04a1c264"), n = n(), _popScopeId(), n); };
var _hoisted_1 = {
    key: 0,
    class: "wrap"
};
var _hoisted_2 = { class: "content" };
var _hoisted_3 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("p", { class: "form-title" }, "产品信息", -1); });
var _hoisted_4 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("p", { class: "form-title" }, "受检人信息", -1); });
var _hoisted_5 = { class: "agree" };
var _hoisted_6 = /*#__PURE__*/ _createTextVNode(" 我已阅读并同意");
var _hoisted_7 = { class: "overlay-wrapper" };
var _hoisted_8 = /*#__PURE__*/ _createTextVNode("支付结果查询中...");
import { ref, watch } from "vue";
import HospitalPicker from "@/components/hospitalPicker.vue";
import InformedConsent from "@/components/informedConsent.vue";
import { useRouter, useRoute } from "vue-router";
import { placeOrder, payOrder, checkPaymentResult, hospitalSalesman, } from "@/api";
import { Toast } from "vant";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ProductDetails',
    setup: function (__props) {
        var _this = this;
        var formRef = ref();
        var route = useRoute();
        var router = useRouter();
        var productName = ref(route.query.skuName);
        var price = Number(route.query.skuPrice);
        var hospitalName = ref("");
        var hospitalId = ref(0);
        var doctor = ref("");
        var examinedName = ref("");
        var documentTypeLabel = ref("身份证");
        var documentTypeId = ref(1);
        var cardNo = ref();
        var hospitalPickerVisible = ref(false);
        var handleHospitalPickerOk = function (id, name) {
            hospitalId.value = id;
            hospitalName.value = name;
            handleHospitalPickerCancel();
        };
        var handleHospitalPickerCancel = function () {
            hospitalPickerVisible.value = false;
        };
        var doctorCascaderVisible = ref(false);
        var salesmanLabel = ref("");
        var salesmanOptions = ref([]);
        var getDoctorList = function () { return __awaiter(_this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, hospitalSalesman(hospitalId.value)];
                    case 1:
                        res = _a.sent();
                        if (res.code === 200) {
                            salesmanOptions.value = res.data.map(function (item) { return ({
                                text: item.salesmanName,
                                value: item.salesmanId,
                            }); });
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        var departId = ref(); //科室id
        var doctorId = ref(); // 医生id
        var salesmanId = ref(); // 销售员id
        var onFinish = function (_a) {
            var selectedOptions = _a.selectedOptions;
            salesmanLabel.value = selectedOptions.map(function (option) { return option.text; }).join("/");
            // departId.value = selectedOptions[0].value;
            // doctorId.value = selectedOptions[1].value;
            salesmanId.value = selectedOptions[0].value;
            doctorCascaderVisible.value = false;
        };
        var documentTypePickerVisible = ref(false);
        var documentTypeColumns = ref([
            { text: "身份证", value: 1 },
            { text: "港澳台居民居住证", value: 2 },
            { text: "护照", value: 3 },
            { text: "台胞证", value: 4 },
            { text: "外国人永久居留身份证", value: 5 },
        ]);
        var onOocumentTypeConfirm = function (_a) {
            var _b, _c;
            var selectedOptions = _a.selectedOptions;
            documentTypeLabel.value = (_b = selectedOptions[0]) === null || _b === void 0 ? void 0 : _b.text;
            documentTypeId.value = (_c = selectedOptions[0]) === null || _c === void 0 ? void 0 : _c.value;
            documentTypePickerVisible.value = false;
        };
        var checked = ref(true);
        var loading = ref(false);
        // 支付订单
        var handlePayrder = function (orderNo) { return __awaiter(_this, void 0, void 0, function () {
            var res, data, timer_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, payOrder({
                            openId: sessionStorage.getItem("openId"),
                            orderNo: orderNo,
                        })];
                    case 1:
                        res = _a.sent();
                        loading.value = false;
                        if (res.code === 200) {
                            data = JSON.parse(res.data);
                            timer_1 = null;
                            wx.chooseWXPay({
                                timestamp: data.timeStamp,
                                nonceStr: data.nonceStr,
                                package: data.package,
                                signType: data.signType,
                                paySign: data.paySign,
                                success: function (res) {
                                    console.log("支付成功" + res);
                                    if (res.errMsg === "chooseWXPay:ok") {
                                        payLoadingVisible.value = true;
                                        timer_1 = setInterval(function () {
                                            checkPaymentResult(orderNo).then(function (res) {
                                                if (res.code === 200) {
                                                    payLoadingVisible.value = false;
                                                    clearInterval(timer_1);
                                                    timer_1 = null;
                                                    router.push({
                                                        path: "/payment-success",
                                                        query: {
                                                            orderNo: orderNo,
                                                            skuName: res.data.skuName,
                                                            orderPrice: res.data.orderPrice,
                                                            payTime: res.data.payTime,
                                                        },
                                                    });
                                                }
                                            });
                                        }, 2000);
                                    }
                                },
                                cancel: function (res) {
                                    console.log(res);
                                },
                                complete: function (res) {
                                    console.log("complete");
                                    if (res.errMsg === "chooseWXPay:cancel") {
                                        if (timer_1) {
                                            clearInterval(timer_1);
                                            timer_1 = null;
                                        }
                                    }
                                },
                            });
                        }
                        else {
                            Toast(res.message);
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        // 创建订单
        var handlePlaceOrder = function () { return __awaiter(_this, void 0, void 0, function () {
            var res, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, placeOrder({
                            cardName: examinedName.value,
                            certificateType: documentTypeId.value,
                            cardNo: cardNo.value,
                            hospitalId: hospitalId.value,
                            // departId: departId.value,
                            // doctorId: doctorId.value,
                            skuId: route.query.skuId,
                            salesmanId: salesmanId.value
                        })];
                    case 1:
                        res = _a.sent();
                        if (res.code == 200) {
                            data = JSON.parse(res.data || '');
                            if (price) {
                                handlePayrder(data === null || data === void 0 ? void 0 : data.orderNo);
                            }
                            else {
                                router.push({
                                    path: "/payment-success",
                                    query: {
                                        orderNo: data === null || data === void 0 ? void 0 : data.orderNo,
                                        skuName: productName.value,
                                        orderPrice: "0.00",
                                        payTime: data === null || data === void 0 ? void 0 : data.createTime,
                                    },
                                });
                            }
                        }
                        else {
                            Toast(res.message);
                            loading.value = false;
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        var handlePayment = function () {
            var _a;
            (_a = formRef.value) === null || _a === void 0 ? void 0 : _a.validate().then(function () { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    if (!checked.value) {
                        return [2 /*return*/, Toast("请同意《用户知情同意书》")];
                    }
                    loading.value = true;
                    handlePlaceOrder();
                    return [2 /*return*/];
                });
            }); });
        };
        watch(hospitalName, function () {
            salesmanLabel.value = "";
            doctorId.value = "";
        });
        var payLoadingVisible = ref(false);
        var imgVisible = ref(false);
        var validatorCardNumber = function () {
            var result = false;
            if (cardNo.value) {
                switch (documentTypeLabel.value) {
                    case "身份证":
                        result = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(cardNo.value);
                        break;
                    case "护照":
                        result = /^((1[45]\d{7})|(G\d{8})|(P\d{7})|(S\d{7,8}))?$/.test(cardNo.value);
                        break;
                    case "港澳台居民居住证":
                    case "台胞证":
                        result = /(^[0-9A-Za-z]{1, 18}$)/.test(cardNo.value);
                        break;
                    case "外国人永久居留身份证":
                        result = /^[a-zA-Z]{3}\d{12}$/.test(cardNo.value);
                        break;
                }
            }
            return result;
        };
        var informedConsentVisible = ref(false);
        return function (_ctx, _cache) {
            var _component_van_icon = _resolveComponent("van-icon");
            var _component_van_nav_bar = _resolveComponent("van-nav-bar");
            var _component_van_field = _resolveComponent("van-field");
            var _component_van_popup = _resolveComponent("van-popup");
            var _component_van_cascader = _resolveComponent("van-cascader");
            var _component_van_picker = _resolveComponent("van-picker");
            var _component_van_form = _resolveComponent("van-form");
            var _component_van_checkbox = _resolveComponent("van-checkbox");
            var _component_van_submit_bar = _resolveComponent("van-submit-bar");
            var _component_van_loading = _resolveComponent("van-loading");
            var _component_van_overlay = _resolveComponent("van-overlay");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                (!informedConsentVisible.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _createVNode(_component_van_nav_bar, {
                            title: productName.value,
                            onClickLeft: _cache[0] || (_cache[0] = function ($event) { return (_unref(router).go(-1)); })
                        }, {
                            left: _withCtx(function () { return [
                                _createVNode(_component_van_icon, {
                                    color: "rgba(0,0,0,0.9)",
                                    name: "arrow-left",
                                    size: "24"
                                })
                            ]; }),
                            _: 1
                        }, 8, ["title"]),
                        _createElementVNode("div", _hoisted_2, [
                            _createVNode(_component_van_form, {
                                ref_key: "formRef",
                                ref: formRef
                            }, {
                                default: _withCtx(function () { return [
                                    _hoisted_3,
                                    _createVNode(_component_van_field, {
                                        modelValue: productName.value,
                                        name: "产品名称",
                                        label: "产品名称",
                                        readonly: ""
                                    }, null, 8, ["modelValue"]),
                                    _createVNode(_component_van_field, {
                                        modelValue: hospitalName.value,
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) { return ((hospitalName).value = $event); }),
                                        name: "就诊医院",
                                        label: "就诊医院",
                                        "is-link": "",
                                        readonly: "",
                                        placeholder: "请选择您就诊的医院",
                                        onClick: _cache[2] || (_cache[2] = function ($event) { return (hospitalPickerVisible.value = true); }),
                                        rules: [{ required: true, message: '请选择您就诊的医院' }]
                                    }, null, 8, ["modelValue"]),
                                    _createVNode(_component_van_popup, {
                                        show: hospitalPickerVisible.value,
                                        "onUpdate:show": _cache[3] || (_cache[3] = function ($event) { return ((hospitalPickerVisible).value = $event); }),
                                        position: "right",
                                        style: { width: '100%', height: '100%' }
                                    }, {
                                        default: _withCtx(function () { return [
                                            (hospitalPickerVisible.value)
                                                ? (_openBlock(), _createBlock(HospitalPicker, {
                                                    key: 0,
                                                    onOk: handleHospitalPickerOk,
                                                    onCancel: handleHospitalPickerCancel
                                                }))
                                                : _createCommentVNode("", true)
                                        ]; }),
                                        _: 1
                                    }, 8, ["show"]),
                                    _createVNode(_component_van_field, {
                                        modelValue: salesmanLabel.value,
                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) { return ((salesmanLabel).value = $event); }),
                                        name: "检测联络员",
                                        label: "检测联络员",
                                        "is-link": "",
                                        readonly: "",
                                        placeholder: "请选择检测联络员",
                                        onClick: _cache[5] || (_cache[5] =
                                            function () {
                                                doctorCascaderVisible.value = true;
                                                getDoctorList();
                                            }),
                                        rules: [{ required: true, message: '请选择检测联络员' }]
                                    }, null, 8, ["modelValue"]),
                                    _createVNode(_component_van_popup, {
                                        show: doctorCascaderVisible.value,
                                        "onUpdate:show": _cache[8] || (_cache[8] = function ($event) { return ((doctorCascaderVisible).value = $event); }),
                                        round: "",
                                        position: "bottom"
                                    }, {
                                        default: _withCtx(function () { return [
                                            _createVNode(_component_van_cascader, {
                                                modelValue: doctor.value,
                                                "onUpdate:modelValue": _cache[6] || (_cache[6] = function ($event) { return ((doctor).value = $event); }),
                                                title: "请选择检测联络员",
                                                options: salesmanOptions.value,
                                                onClose: _cache[7] || (_cache[7] = function ($event) { return (doctorCascaderVisible.value = false); }),
                                                onFinish: onFinish
                                            }, null, 8, ["modelValue", "options"])
                                        ]; }),
                                        _: 1
                                    }, 8, ["show"]),
                                    _hoisted_4,
                                    _createVNode(_component_van_field, {
                                        modelValue: examinedName.value,
                                        "onUpdate:modelValue": _cache[9] || (_cache[9] = function ($event) { return ((examinedName).value = $event); }),
                                        name: "受检人",
                                        label: "受检人",
                                        placeholder: "请输入受检人姓名",
                                        rules: [{ required: true, message: '请输入受检人姓名' }]
                                    }, null, 8, ["modelValue"]),
                                    _createVNode(_component_van_field, {
                                        modelValue: documentTypeLabel.value,
                                        "onUpdate:modelValue": _cache[10] || (_cache[10] = function ($event) { return ((documentTypeLabel).value = $event); }),
                                        "is-link": "",
                                        readonly: "",
                                        name: "documentTypePicker",
                                        label: "证件类型",
                                        placeholder: "请选择证件类型",
                                        onClick: _cache[11] || (_cache[11] = function ($event) { return (documentTypePickerVisible.value = true); }),
                                        rules: [{ required: true, message: '请选择证件类型' }]
                                    }, null, 8, ["modelValue"]),
                                    _createVNode(_component_van_popup, {
                                        show: documentTypePickerVisible.value,
                                        "onUpdate:show": _cache[13] || (_cache[13] = function ($event) { return ((documentTypePickerVisible).value = $event); }),
                                        position: "bottom"
                                    }, {
                                        default: _withCtx(function () { return [
                                            _createVNode(_component_van_picker, {
                                                columns: documentTypeColumns.value,
                                                onConfirm: onOocumentTypeConfirm,
                                                onCancel: _cache[12] || (_cache[12] = function ($event) { return (documentTypePickerVisible.value = false); })
                                            }, null, 8, ["columns"])
                                        ]; }),
                                        _: 1
                                    }, 8, ["show"]),
                                    _createVNode(_component_van_field, {
                                        modelValue: cardNo.value,
                                        "onUpdate:modelValue": _cache[14] || (_cache[14] = function ($event) { return ((cardNo).value = $event); }),
                                        label: "证件号码",
                                        placeholder: "请填写证件号码",
                                        formatter: function (value) { return value.replace(/\W/g, ''); },
                                        rules: [
                                            { required: true, message: '请填写证件号码' },
                                            { validator: validatorCardNumber, message: '请输入正确的证件号码' },
                                        ]
                                    }, null, 8, ["modelValue", "formatter", "rules"])
                                ]; }),
                                _: 1
                            }, 512),
                            _createElementVNode("div", _hoisted_5, [
                                _createVNode(_component_van_checkbox, {
                                    modelValue: checked.value,
                                    "onUpdate:modelValue": _cache[15] || (_cache[15] = function ($event) { return ((checked).value = $event); }),
                                    "icon-size": "0.28rem",
                                    "checked-color": "#3DABA4"
                                }, null, 8, ["modelValue"]),
                                _createElementVNode("p", null, [
                                    _hoisted_6,
                                    _createElementVNode("span", {
                                        style: { color: '#3DABA4' },
                                        onClick: _cache[16] || (_cache[16] = function ($event) { return (informedConsentVisible.value = true); })
                                    }, "《用户知情同意书》")
                                ])
                            ])
                        ]),
                        _createVNode(_component_van_submit_bar, {
                            style: { color: '#3DABA4' },
                            price: _unref(price) * 100,
                            "button-text": "确认支付",
                            "text-align": "left",
                            label: " ",
                            "button-color": "#3DABA4",
                            onSubmit: handlePayment,
                            loading: loading.value
                        }, null, 8, ["price", "loading"]),
                        _createVNode(_component_van_overlay, {
                            show: payLoadingVisible.value,
                            style: { zIndex: 100 }
                        }, {
                            default: _withCtx(function () { return [
                                _createElementVNode("div", _hoisted_7, [
                                    _createVNode(_component_van_loading, {
                                        color: "#0094ff",
                                        size: "24px",
                                        vertical: ""
                                    }, {
                                        default: _withCtx(function () { return [
                                            _hoisted_8
                                        ]; }),
                                        _: 1
                                    })
                                ])
                            ]; }),
                            _: 1
                        }, 8, ["show"])
                    ]))
                    : _createCommentVNode("", true),
                (informedConsentVisible.value)
                    ? (_openBlock(), _createBlock(InformedConsent, {
                        key: 1,
                        isVanPopup: true,
                        onCancel: _cache[17] || (_cache[17] = function ($event) { return (informedConsentVisible.value = false); })
                    }))
                    : _createCommentVNode("", true)
            ], 64));
        };
    }
});
